import React, { useMemo, useState } from 'react';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { useIntl } from 'react-intl';
import IntlMessages from 'Util/IntlMessages';
import { PatternFormat } from 'react-number-format';

const FormatNumberInput = ({
  format = '###-##-###############',
  value,
  onValueChange,
  label,
  placeholder: propsPlaceholder,
  isError = false,
  errorText,
  isShowPlaceholder = false,
  maxLength,
  tabIndex = 0,
  focusLabel,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const [isFocus, setIsFocus] = useState(false);
  const placeholder = useMemo(() => {
    if (propsPlaceholder === undefined) return label;
    if (isShowPlaceholder) return propsPlaceholder;
    if (!isFocus) return label;
    return propsPlaceholder;
  }, [isFocus, label, propsPlaceholder, isShowPlaceholder]);
  return (
    <FormControl
      error={isError}
      fullWidth
      variant="outlined"
      sx={{
        '& label': {
          color: '#000',
          fontFamily: 'Pretendard',
        },
        '& label.Mui-focused': {
          color: '#000',
        },
        '& label.Mui-error': {
          color: '#000',
        },

        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderRadius: '10px',
            border: '1px solid #ddd',
          },
          '&:hover fieldset': {
            borderColor: '#000',
          },
          '&.Mui-focused fieldset': {
            border: '1px solid #000',
          },
          '&.Mui-error fieldset': {
            border: '1px solid #FF4B4B',
          },
        },
      }}
    >
      {(isFocus || value) && <InputLabel htmlFor={label}>{formatMessage({ id: label })}</InputLabel>}
      <PatternFormat
        id={label}
        value={value}
        onValueChange={onValueChange}
        format={format}
        allowEmptyFormatting={false}
        mask=""
        type={'text'}
        placeholder={formatMessage({ id: placeholder })}
        label={formatMessage({ id: label })}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={() => {
          setIsFocus(false);
        }}
        customInput={OutlinedInput}
        inputProps={{
          style: {
            color: '#222',
            fontFamily: 'Pretendard',
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            padding: '15px',
          },
          tabIndex,
        }}
        {...props}
      />
      {isError && errorText && <div className="error-text">{errorText}</div>}
      {isFocus && focusLabel && (
        <div className="focus-text">
          <IntlMessages id={focusLabel} />
        </div>
      )}
    </FormControl>
  );
};

export default FormatNumberInput;
